import React from 'react'
import { AbStickyPhone } from 'ppp'
import { useProject } from 'shared'
import { StickyProps } from './types'

//Todo: Add correct type
export const AbSticky = ({ apiUrl }: StickyProps): JSX.Element => {
  const { status, ...project } = useProject(apiUrl)

  return <AbStickyPhone project={project} status={status} />
}
